import { useEffect } from 'react';
import useGameStore from '../store/gameStore';

/**
 * Purchase announcement: fires for ~2s whenever ANY bot acquires shares
 * (direct buy, governance accumulation or auction win) so purchases are obvious.
 */
const BotPurchaseToast = () => {
  const toast = useGameStore((s) => s.botPurchaseToast);
  const clearBotPurchaseToast = useGameStore((s) => s.clearBotPurchaseToast);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => clearBotPurchaseToast(), 2000);
    return () => window.clearTimeout(timer);
  }, [toast, clearBotPurchaseToast]);

  if (!toast) return null;
  return (
    <div className="pointer-events-none fixed bottom-20 left-1/2 z-[75] -translate-x-1/2 md:bottom-6">
      <div
        className="flex items-center gap-2.5 rounded-full border-2 px-5 py-2.5 text-sm font-extrabold text-white shadow-[0_12px_44px_rgba(0,0,0,0.65)] backdrop-blur bot-purchase-toast"
        style={{ borderColor: toast.color, backgroundColor: `${toast.color}33`, boxShadow: `0 0 18px ${toast.color}88` }}
      >
        <span>{toast.text}</span>
      </div>
    </div>
  );
};

export default BotPurchaseToast;
